import React, { useState, useEffect } from 'react';
import { 
  Add,
} from '@mui/icons-material';
import { Tooltip, Fab } from "@mui/material";

import Grid from '@mui/material/Grid2';

import { 
  AbilityEffect,
  ExtraEffectsOfTypeFeature,
} from "@dndModels";

import ToggleButtonBox from "@components/input/buttons/ToggleButtonBox";
import AbilityEffectInput from "@dndComponents/feature/AbilityEffectInput";
import StringBox from "@components/input/strings/StringBox";

interface Props { 
  obj: ExtraEffectsOfTypeFeature;
  onChange: (changed: ExtraEffectsOfTypeFeature) => void;
  disabled: boolean;
}

export default function ExtraEffectsOfTypeFeatureInput({ 
  obj,
  onChange,
  disabled 
}: Props) {
  const [reloading, setReloading] = useState(false);
  const [myObj, setMyObj] = useState(obj.clone());
  const [show_effect, setShowEffect] = useState("");
  // const [special_refresh_rule, setSpecialRefreshRule] = useState(false);
  
  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading, setReloading]);

  // const refresh_rule_helper = REFRESH_RULES.includes(obj.special_resource_refresh_rule) ? obj.special_resource_refresh_rule : "Special";
  return (
    <Grid container spacing={0} direction="row">
      <Grid
        size={{
          xs: 12
        }}>
        <StringBox
          name="Extra Effect Type"
          value={myObj.ee_type}
          disabled={disabled}
          onBlur={(changed: string) => {
            const new_obj = myObj;
            new_obj.ee_type = changed;
            setMyObj(new_obj);
            onChange(new_obj);
          }}
        />
      </Grid>
      <Grid
        size={{
          xs: 12
        }}>
        <span className="header">
          Effects
        </span>
        { !disabled &&
          <Tooltip title={`Add Effect`}>
            <Fab size="small" color="primary" style={{marginLeft: "8px"}}
              onClick={ () => {
                const new_obj = myObj;
                const effect = new AbilityEffect();
                new_obj.effects.push(effect);
                setMyObj(new_obj);
                onChange(new_obj);
                setShowEffect(effect.true_id);
                setReloading(true);
              }}>
              <Add/>
            </Fab>
          </Tooltip>
        }
      </Grid>
      { !reloading && myObj.effects.map((effect, key) => {
        let name = effect.type === "Damage" ? effect.damage_types.join(", ") : effect.type;
        if (effect.name !== "") {
          name += " " + effect.name;
        }
        if (!["None","Self Condition"].includes(effect.type) && effect.attack_type !== "None") {
          name += ` ${effect.attack_type}`;
        }
        return (
          <Grid
            key={key}
            container
            spacing={0}
            direction="row"
            size={{
              xs: 12
            }}>
            <Grid
              size={{
                xs: 12
              }}>
              <ToggleButtonBox
                name={ name }
                value={ show_effect === effect.true_id }
                disabled={disabled}
                onToggle={ () => { 
                  setShowEffect(show_effect === effect.true_id ? "" : effect.true_id);
                }}
              />
            </Grid>
            { show_effect === effect.true_id && 
              <AbilityEffectInput 
                obj={effect}
                disabled={disabled}
                onChange={() => {
                  const new_obj = myObj;
                  onChange(new_obj);
                  setMyObj(new_obj);
                  // setReloading(true);
                }}
                onDelete={() => {
                  const new_obj = myObj;
                  new_obj.effects = new_obj.effects.filter(o => o.true_id !== effect.true_id);
                  onChange(new_obj);
                  setMyObj(new_obj);
                  // setReloading(true);
                }}
              />
            }
          </Grid>
        );
      })}
    </Grid>
  );
}
